module.exports = __webpack_public_path__ + "img/icon_mainMenu01.6de7ebc2.svg";